module.exports = __webpack_public_path__ + "static/team-ruth-08866b67ccedbe95c738794b7b95de07.jpg";